import React from "react";
import { Power } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function AvailabilityToggle({ lawyer, onToggle }) {
  const online = !!lawyer.available;
  const blocked = (lawyer.account_status || "active") !== "active";
  if (blocked) return null;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button onClick={() => onToggle(lawyer)} data-testid={`avail-toggle-${lawyer.id}`}
                  aria-label={online ? "Set offline" : "Set online"}
                  className={`px-2 py-1 text-xs font-bold rounded-md border ${online ? "border-slate-300 text-slate-700 hover:bg-slate-50" : "border-emerald-300 text-emerald-700 hover:bg-emerald-50"}`}>
            <Power size={10} className="inline" /> {online ? "Set offline" : "Set online"}
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs bg-[#0A2540] text-white" data-testid={`avail-toggle-${lawyer.id}-tooltip`}>
          <p className="font-bold">{online ? "Take this lawyer offline" : "Put this lawyer online"}</p>
          <p className="mt-1 font-normal leading-relaxed text-slate-200">
            {online
              ? "Stops new instant bookings immediately. Scheduled consultations and marketplace listing are not affected. The lawyer can go online again from their portal."
              : "Lets users start instant consultations with this lawyer right now — the same switch the lawyer has in their portal. Has no effect on visibility unless the lawyer is verified and listed."}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
